// extracted by mini-css-extract-plugin
export default {"container":"InputWithLabels_container__xaqcf","labels":"InputWithLabels_labels__ym4SN"};